import {apiClient} from 'core/apiClient';
import {Participant} from 'types/participants';
import {StorageListRequest, StoragePaginationContent, StorageRawRow} from 'types/profile';

export async function fetchStoragesList(
    params: StorageListRequest,
): Promise<StoragePaginationContent<StorageRawRow>> {
    return (
        await apiClient.post<StoragePaginationContent<StorageRawRow>>('service/storages', params, {
            baseURL: '/api/v2',
        })
    ).data;
}

export async function fetchStorageDetails(clientId: string | number): Promise<Participant> {
    return (await apiClient.get<Participant>(`uaa/clients/${clientId}`)).data;
}
